module.exports = __webpack_public_path__ + "img/frame-material.8e2cae50.png";